<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { NoraChat } from '@nora-monorepo/nora-chat-ui';
import {
  ErrorScreen,
  SplashScreen,
  useWebViewStore,
} from '@nora-monorepo/ui-shared';

import LeftNavigationRail from '#nora-ui/LeftNavigationRail.vue';
import Maps from '#nora-ui/map/Maps.vue';
import Modals from '#nora-ui/Modals.vue';
import { useRouteFlags } from '#nora-ui/router/route-flags';
import { BootstrapPhase, useBootstrapStore } from '#nora-ui/stores/bootstrap-store';

const bootstrapStore = useBootstrapStore();
const webViewStore = useWebViewStore();

const { isReady, isBootstrapping, phase } = storeToRefs(bootstrapStore);
const { isWebView } = storeToRefs(webViewStore);

const { isChatRoute, hasPanel } = useRouteFlags();
const shouldShowPanelContainer = computed(
  () => !isWebView.value && hasPanel.value,
);
</script>

<template>
  <SplashScreen
    v-if="isBootstrapping"
    nora-full
    text="Loading..."
  />

  <ErrorScreen
    v-else-if="phase === BootstrapPhase.NO_USER"
    title="No access"
    message="We couldn't find an account for you. Please sign in with an authorized user."
  />

  <ErrorScreen
    v-else-if="phase === BootstrapPhase.ERROR"
    title="Something went wrong while starting NORA"
    message="Please check your connection and try again."
    show-reload
  />

  <div
    v-else-if="isReady"
    class="flex flex-row h-full w-full overflow-hidden"
  >
    <LeftNavigationRail v-if="!isWebView" />

    <div class="relative flex flex-row flex-1 h-full overflow-hidden">
      <div
        v-show="shouldShowPanelContainer"
        class="h-full max-h-full min-w-90 max-w-90 bg-light-bg-primary dark:bg-dark-bg-primary w-full shadow-2xl"
      >
        <NoraChat
          v-show="isChatRoute"
          :responsive-to-container="true"
        />
        <RouterView name="panel" />
      </div>

      <div class="flex flex-col h-full w-full">
        <div class="grow max-h-full h-full w-full">
          <Maps />
        </div>
      </div>

      <RouterView
        v-slot="{ Component }"
        name="overlay"
      >
        <div
          v-if="Component"
          class="absolute inset-0 z-50"
        >
          <component :is="Component" />
        </div>
      </RouterView>
    </div>
  </div>

  <Modals v-if="isReady" />
</template>
